import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.MissionAndVisionView.heading',
    defaultMessage: 'Misja i Wizja'
  },
  valuesWeBelive: {
    id: 'views.MissionAndVisionView.valuesWeBelive',
    defaultMessage: 'Wartości, w które wierzymy:'
  },
  bigBoxTitleItem1: {
    id: 'views.MissionAndVisionView.bigBox.title.item1',
    defaultMessage: 'Nie tylko nadążać za światem, ale go wyprzedzać'
  },
  bigBoxDescriptionItem1: {
    id: 'views.MissionAndVisionView.bigBox.description.item1',
    defaultMessage:
      'Świat biznesu jest stale konfrontowany z rosnącą konkurencją oraz nieustannymi zmianami technicznymi, operacyjnymi i ekonomicznymi. Grupa TenderHut chce dostarczać dedykowane usługi zapewniając klientom możliwości sprostania wyzwaniom ich życia biznesowego.'
  },
  bigBoxLogoDescriptionItem1: {
    id: 'views.MissionAndVisionView.bigBox.logo.description.item1',
    defaultMessage: 'Misja'
  },
  bigBoxTitleItem2: {
    id: 'views.MissionAndVisionView.bigBox.title.item2',
    defaultMessage: 'Jako TenderHut chcemy tworzyć IT dla świata'
  },
  bigBoxDescriptionItem2: {
    id: 'views.MissionAndVisionView.bigBox.description.item2',
    defaultMessage:
      'Systemy informatyczne są obecnie integralną częścią codziennego życia wszystkich ludzi. Obsługują one podstawowe potrzeby życiowe ludzi, a także wspomagają procesy produkcyjne we wszystkich dziedzinach gospodarki, zaopatrzenia, zarządzania i usług. Grupa TenderHut chce tworzyć systemy IT dla świata.'
  },
  bigBoxLogoDescriptionItem2: {
    id: 'views.MissionAndVisionView.bigBox.logo.description.item2',
    defaultMessage: 'Wizja'
  },
  smallBoxTitleItem1: {
    id: 'views.MissionAndVisionView.smallBox.title.item1',
    defaultMessage: 'Innowacje w biznesie'
  },
  smallBoxDescriptionItem1: {
    id: 'views.MissionAndVisionView.smallBox.description.item1',
    defaultMessage:
      'Innowacja jest i zawsze będzie naszym znakiem rozpoznawczym, dobrze wiemy, że gwarantuje nam ona powodzenie w przyszłości. Wdrażamy innowacyjne rozwiązania nie tylko w kontekście systemów IT, ale również poprzez innowacyjne podejście do biznesu, niestandardową realizację usług, nietypowe podejście do bycia pracodawcą i nowoczesne zarządzanie firmą.'
  },
  smallBoxTitleItem2: {
    id: 'views.MissionAndVisionView.smallBox.title.item2',
    defaultMessage: 'Poszerzanie horyzontów'
  },
  smallBoxDescriptionItem2: {
    id: 'views.MissionAndVisionView.smallBox.description.item2',
    defaultMessage:
      'Skupiamy się na tym, aby nasi pracownicy stale poszerzali swoją wiedzę i kompetencje. Stworzyliśmy zespół SoftwareHut Speaking. To wykwalifikowana grupa programistów szerzących wiedzę z zakresu IT na konferencjach branżowych, meetupach i warsztatach. To ludzie zaangażowani w życie społeczności IT, którzy chcą dzielić się swoją wiedzą i dobrymi praktykami z zakresu programowania.'
  },
  smallBoxTitleItem3: {
    id: 'views.MissionAndVisionView.smallBox.title.item3',
    defaultMessage: 'Ludzie'
  },
  smallBoxDescriptionItem3: {
    id: 'views.MissionAndVisionView.smallBox.description.item3',
    defaultMessage:
      'Pracownicy to nasz najcenniejszy kapitał. Jedynie pracownicy, którzy mają szansę zachowania równowagi pomiędzy życiem zawodowym, a prywatnym, będą w pełni efektywni i związani z firmą na dłużej. Dla naszych pracowników znaczenie mają: rozwój osobisty, możliwość samorealizacji, poczucie bezpieczeństwa dzięki stabilności warunków zatrudnienia, możliwość pracy zdalnej, inne niż standardowe godziny pracy.'
  },
  smallBoxTitleItem4: {
    id: 'views.MissionAndVisionView.smallBox.title.item4',
    defaultMessage: 'Integracja Branży IT'
  },
  smallBoxDescriptionItem4: {
    id: 'views.MissionAndVisionView.smallBox.description.item4',
    defaultMessage:
      'Angażowanie lokalnego środowiska IT we współpracy z administracją rządową i samorządową, instytucjami naukowymi i badawczymi oraz regionalnymi firmami z branży IT. Przedsiębiorstwa zrzeszone w klastrze IT rozwijają się szybciej osiągając jednocześnie lepsze wyniki niż konkurencja, która będzie niezrzeszona.'
  }
});



// WEBPACK FOOTER //
// ./src/views/MissionAndVision/MissionAndVisionView.intl.js